
import { UserModule } from '@/store/modules/user';
import { Component, Vue } from 'vue-property-decorator';
import { createOrderService } from '@/api/orderService';
import { getDepartmentList } from '@/api/company';
import { getInstallScourceList } from '@/api/installScource';
import { addCustomer } from '@/api/customer';
import OrderTag from '../order/components/OrderTag.vue';
import OrderBrand from '../order/components/OrderBrand.vue';
import OrderDevice from '@/components/DeviceSelectDialog/index.vue';
import OrdertParts from '../order/components/OrderParts.vue';
import CustomerDialog from '../../components/CustomerDialog/levelByLevel.vue';
import OrderArea from '../order/components/OrderArea.vue';
import CustomerAddDialog from '../customer/components/CustomerAddDialog.vue';
import SelectDepartment from '../../components/DeptDialog/index.vue';
import OrderAddressCustom from '../order/components/OrderAddressCustom.vue';
import { addOrderServerIsHave, addOrderServerIsMust, checkPermissionCompany } from '@/utils/permission';
import { OrderType, Type } from '../../types/permissionType';
import { getPriceList } from '@/api/other';

@Component({
  name: 'OrderInstallAdd',
  components: {
    OrderTag,
    OrderBrand,
    OrderDevice,
    OrdertParts,
    CustomerDialog,
    OrderArea,
    CustomerAddDialog,
    SelectDepartment,
    OrderAddressCustom
  }
})
export default class extends Vue {
  private servicerChange(orderType:any) {
    this.isShowTag = addOrderServerIsHave(Type.tag, orderType, '');
    this.isShowSerDept = addOrderServerIsHave(Type.dept, orderType, '');
    this.isShowProduct = addOrderServerIsHave(Type.product, orderType, '');
    this.isShowDevice = addOrderServerIsHave(Type.device, orderType, '');
    this.isShowParts = addOrderServerIsHave(Type.parts, orderType, '');
    this.isShowRemark = addOrderServerIsHave(Type.remark, orderType, '');
    this.isShowAppointment = addOrderServerIsHave(Type.time, orderType, '');
    this.isShowPrice = addOrderServerIsHave(Type.price, orderType, '');
    this.isShowAddressPca = addOrderServerIsHave(Type.pca, orderType, '');
    this.isShowAddressSelf = addOrderServerIsHave(Type.myselfPCALs, orderType, '');
    this.isShowAddress = addOrderServerIsHave(Type.address, orderType, '');
    this.isShowContentUser = addOrderServerIsHave(Type.contentUser, orderType, '');
    this.isShowContentUserMobile = addOrderServerIsHave(Type.contentUserMobile, orderType, '');
    this.isShowContentUserPhone = addOrderServerIsHave(Type.contentUserPhone, orderType, '');
    this.isShowDescription = addOrderServerIsHave(Type.Description, orderType, '');

    this.isMustTag = addOrderServerIsMust(Type.tag, orderType, '');
    this.isMustSerDept = addOrderServerIsMust(Type.dept, orderType, '');
    this.isMustProduct = addOrderServerIsMust(Type.product, orderType, '');
    this.isMustDevice = addOrderServerIsMust(Type.device, orderType, '');
    this.isMustParts = addOrderServerIsMust(Type.parts, orderType, '');
    this.isMustRemark = addOrderServerIsMust(Type.remark, orderType, '');
    this.isMustAppointment = addOrderServerIsMust(Type.time, orderType, '');
    this.isMustPrice = addOrderServerIsMust(Type.price, orderType, '');
    this.isMustAddressPca = addOrderServerIsMust(Type.pca, orderType, '');
    this.isMustAddressSelf = addOrderServerIsMust(Type.myselfPCALs, orderType, '');
    this.isMustAddress = addOrderServerIsMust(Type.address, orderType, '');

    this.isMustContentUser = addOrderServerIsMust(Type.contentUser, orderType, '');
    this.isMustContentUserMobile = addOrderServerIsMust(Type.contentUserMobile, orderType, '');
    this.isMustContentUserPhone = addOrderServerIsMust(Type.contentUserPhone, orderType, '');
    this.isMustDescription = addOrderServerIsMust(Type.Description, orderType, '');
    if (this.isShowSerDept) {
      this.getDeptList();
    }
    this.isShowInstallSource = addOrderServerIsHave(Type.InstallOrderSource, orderType, '');
    this.isShowInstallNum = addOrderServerIsHave(Type.InstallOrderNum, orderType, '');
    this.isShowInstallAppointment = addOrderServerIsHave(Type.InstallOrderAppointment, orderType, '');

    this.isMustInstallSource = addOrderServerIsMust(Type.InstallOrderSource, orderType, '');
    this.isMustInstallNum = addOrderServerIsMust(Type.InstallOrderNum, orderType, '');
    this.isMustInstallAppointment = addOrderServerIsMust(Type.InstallOrderAppointment, orderType, '');
    if (this.isShowInstallSource) {
      this.getInstallScourceList();
    }
  }

  private isShowTag=false;
  private isMustTag=false;

  private isShowSerDept=false;
  private isMustSerDept=false;

  private isShowProduct=false;
  private isMustProduct=false;

  private isShowDevice=false;
  private isMustDevice=false;

  private isShowParts=false;
  private isMustParts=false;

  private isShowRemark=false;
  private isMustRemark=false;

  private isShowAppointment=false;
  private isMustAppointment=false;

  private isShowPrice=false;
  private isMustPrice=false;

  private isShowAddressPca=false;
  private isMustAddressPca=false;
  private isShowAddressSelf=false;
  private isMustAddressSelf=false;

  // 默认显示
  private isShowAddress=true;
  private isShowContentUser=true;
  private isShowContentUserMobile=true;
  private isShowContentUserPhone=true;
  private isShowDescription=true;

  private isMustAddress=false;
  private isMustContentUser=false;
  private isMustContentUserMobile=false;
  private isMustContentUserPhone=false;
  private isMustDescription=false;

  private isShowInstallSource=false;
  private isShowInstallNum=false;
  private isShowInstallAppointment=false;

  private isMustInstallSource=false;
  private isMustInstallNum=false;
  private isMustInstallAppointment=false;

  private isShowCustomer=parseInt(((UserModule.getCompany as any).vip_level).substring(0, 1)) === 3
  // 指派部门
  private serDealDeptment=UserModule.getUserDeptList;
  // 服务部门
  private serDeptOptions:any = []

  private formInstall:any = {
    source: '',
    ordernumberOriginal: '',
    appointmentOriginal: '',
    servicerDept: {},
    description: '',
    customer: {},
    area: '',
    address: '',
    name: '',
    mobile: '',
    phone: '',
    appointment: '',
    costRadio: '',
    brand: '',
    device: '',
    parts: '',
    remark: '',
    isSelf: false,
    sendDept: (UserModule.getUserDeptList && UserModule.getUserDeptList.length === 1) ? UserModule.getUserDeptList[0] : ''
  }

  private dynamicCost:any = [];
  private costList:any = [];

  private serverCompanyId:string=''
  private serverCompanyName:string=''
  private sourceOptions: any = []

  created() {
    this.serverCompanyId = UserModule.getCompanyId;
    this.serverCompanyName = UserModule.getCompanyName;
    this.servicerChange(OrderType.InstallModule);
  }
  // 选择部门
  getDeptList() {
    const params = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      type: 9,
      dept_type: 2,
      page: 1
    };
    getDepartmentList(params).then(res => {
      if (res.data) {
        this.serDeptOptions = res.data.list;
      } else {
        this.serDeptOptions = [];
      }
    }).catch(err => {
      this.showErrorMsg(err.msg);
    });
  }

  private departmentVisible = false
  private title = '选择部门'

  private selectDeptServicerHandle() {
    this.departmentVisible = true;
  }
  private selectDept(val:any) {
    this.formInstall.servicerDept = val;
  }
  private closeDeptHandle(value: boolean) {
    this.departmentVisible = value;
  }
  private placeHolderDescription:string= '任务描述';
  // 订单标签
  private selectTagArray:any = []
  private tagVisible = false
  private selectTag() {
    if (this.selectTagArray && this.selectTagArray.length >= 3) {
      this.showErrorMsg('最多只能选择3个标签');
      return;
    }
    if (this.serverCompanyId) {
      this.tagVisible = true;
    }
  }

  private closeTagHandle(value:boolean) {
    this.tagVisible = value;
  }
  private delTagHandle(val: any) {
    this.selectTagArray.splice(this.selectTagArray.indexOf(val), 1);
  }
  private confirmTagHandle(value:any) {
    this.tagVisible = false;
    let filter = this.selectTagArray.filter((tag:any) => {
      return tag.tags_id === value.tags_id;
    });
    if (filter && filter.length > 0) {
      return;
    }
    this.selectTagArray.push(value);
    let descriptionPlaceholdera = '';
    if (this.selectTagArray && this.selectTagArray.length > 0) {
      for (var i = 0; i < this.selectTagArray.length; i++) {
        if (this.selectTagArray[i].trouble_describle_prompt) {
          descriptionPlaceholdera += (this.selectTagArray[i].trouble_describle_prompt + ';');
        }
      }
    }
    if (descriptionPlaceholdera && descriptionPlaceholdera.length > 0) {
      this.placeHolderDescription = descriptionPlaceholdera.slice(0, descriptionPlaceholdera.length - 1);
    }

  }
  // 任务描述
  private dynamicDescription:any[] = []
  private descriptionAddHandle() {
    if (this.dynamicDescription && this.dynamicDescription.length > 3) {
      this.$alert('最多添加5条任务描述', '提示', {
        confirmButtonText: '确定'
      });
    } else {
      this.dynamicDescription.push({
        value: ''
      });
    }
  }
  private descriptionDeleteHandle(value: any) {
    // 删除新增的任务描述
    let index = this.dynamicDescription.indexOf(value);
    if (index !== -1) {
      this.dynamicDescription.splice(index, 1);
    }
  }
  // 选择客户
  private customerDialogVisible=false;
  private selectCustomerVisible() {
    this.customerDialogVisible = true;
  }
  private closeCustomerDialog(val:any) {
    this.customerDialogVisible = val;
  }
  private SelectCus(cus:any) {
    this.formInstall.customer = cus;
    this.provinceName = cus.province_name;
    this.province = cus.province;
    this.cityName = cus.city_name;
    this.city = cus.city;
    this.districtName = cus.district_name;
    this.district = cus.district;
    if (this.provinceName) {
      this.formInstall.area = this.provinceName !== this.cityName
        ? this.provinceName + '  ' + this.cityName + '  ' + this.districtName
        : this.provinceName + '  ' + this.districtName;
    }
    this.$set(this.formInstall, 'address', cus.address);
    this.formInstall.name = cus.manager;
    this.formInstall.mobile = cus.mobile;
    this.formInstall.phone = cus.phone_num;
  }
  // 添加客户
  private dialogAddCustomerVisible=false
  private closeAddCustomerDialog(val: any) {
    this.dialogAddCustomerVisible = val;
  }
  private addCustomerHandle(params: any) {
    addCustomer(params).then(res => {
      this.adcode = params.adcode;
      this.provinceName = params.provinceName;
      this.province = params.province;
      this.cityName = params.cityName;
      this.city = params.city;
      this.districtName = params.districtName;
      this.district = params.district;
      if (this.provinceName) {
        this.formInstall.area = this.provinceName !== this.cityName
          ? this.provinceName + '  ' + this.cityName + '  ' + this.districtName
          : this.provinceName + '  ' + this.districtName;
      }
      this.$set(this.formInstall, 'address', params.address);
      this.formInstall.mobile = params.mobile;
      this.formInstall.phone = params.phone;
      this.formInstall.customer = {};
      switch (parseInt(params.type)) {
        case 1:
          // 公司
          this.formInstall.customer.customer_company_id = (res as any).data.id;
          this.formInstall.customer.name = params.name;
          this.formInstall.customer.customer_type = params.type;
          this.formInstall.name = params.manager;
          break;
        case 2:
          // 个人
          this.formInstall.name = params.name;
          this.formInstall.customer.customer_user_id = (res as any).data.uid;
          this.formInstall.customer.name = params.name;
          this.formInstall.customer.customer_type = params.type;
          break;
      }

      this.dialogAddCustomerVisible = false;
      this.showSecussMsg((res as any).msg);
    }).catch(err => {
      this.showErrorMsg(err.msg);
    });
  }
  // 选择省市区
  private areaVisible = false
  private provinceName=''
  private province=''
  private cityName=''
  private city=''
  private districtName=''
  private district=''
  private adcode=''
  private selectAreaHandle() {
    if (this.isShowAddressPca) {
      this.areaVisible = true;
    } else if (this.isShowAddressSelf) {
      this.areaCustomVisible = true;
    }
  }
  private closeAreaHandle(value:boolean) {
    this.areaVisible = value;
  }
  private saveAreaHandle(value:any) {
    this.adcode = '';
    this.provinceName = value.provinceName;
    this.province = value.province;
    this.cityName = value.cityName;
    this.city = value.city;
    this.districtName = value.districtName;
    this.district = value.district;
    this.formInstall.area = value.province_name !== value.city_name
      ? value.province_name + '  ' + value.city_name + '  ' + value.district_name
      : value.province_name + '  ' + value.district_name;
    this.areaVisible = false;
  }
  // 选择自定义
  private areaCustomVisible = false
  private oneAddress=''
  private oneAddressId=''
  private twoAddress=''
  private twoAddressId=''
  private threeAddress=''
  private threeAddressId=''
  private saveAreaCustomHandle(value:any) {
    this.areaCustomVisible = false;
    if (value) {
      if (value.pBean && value.pBean1) {
        this.oneAddress = JSON.parse(value.pBean).address;
        this.oneAddressId = JSON.parse(value.pBean).id;
        this.twoAddress = JSON.parse(value.pBean1).address;
        this.twoAddressId = JSON.parse(value.pBean1).id;
        this.threeAddress = value.address;
        this.threeAddressId = value.id;
      } else if (value.pBean) {
        this.oneAddress = JSON.parse(value.pBean).address;
        this.oneAddressId = JSON.parse(value.pBean).id;
        this.twoAddress = value.address;
        this.twoAddressId = value.id;
        this.threeAddress = '';
        this.threeAddressId = '0';
      } else {
        this.oneAddress = value.address;
        this.oneAddressId = value.id;
        this.twoAddress = '';
        this.twoAddressId = '0';
        this.threeAddress = '';
        this.threeAddressId = '0';
      }
    }
    this.formInstall.area = this.oneAddress + '  ' + this.twoAddress + '  ' + this.threeAddress;
  }
  private closeAreaCustomHandle(value:boolean) {
    this.areaCustomVisible = value;
  }
  // 原始预约时间
  private appointmentOriginalDayTimestamp:any=''
  private pickerOriginalChange(val:any) {
    if (!val) {
      this.appointmentOriginalDayTimestamp = ''
      return
    }
    let minite = val.slice(-2);
    let hour = val.slice(-5, -3);
    val = val.slice(0, -5);
    let minite2 = '00';
    let i = Math.ceil(parseInt(minite) / 5);
    if (i * 5 < 10) {
      minite2 = '0' + i * 5;
    } else {
      minite2 = '' + i * 5;
    }
    val = val + hour + ':' + minite2;
    let ieval = val.replace(/-/g, '/');
    let data = new Date(ieval);
    this.appointmentOriginalDayTimestamp = data.getTime() / 1000;
    this.formInstall.appointmentOriginal = val;
  }
  // 预约时间
  private appointmentDayTimestamp:any=''
  private pickerChange(val:any) {
    if (!val) {
      this.appointmentDayTimestamp = ''
      return
    }
    let minite = val.slice(-2);
    let hour = val.slice(-5, -3);
    val = val.slice(0, -5);
    let minite2 = '00';
    let i = Math.ceil(parseInt(minite) / 5);
    if (i * 5 < 10) {
      minite2 = '0' + i * 5;
    } else {
      minite2 = '' + i * 5;
    }
    val = val + hour + ':' + minite2;
    let ieval = val.replace(/-/g, '/');
    let data = new Date(ieval);
    this.appointmentDayTimestamp = data.getTime() / 1000;
    this.formInstall.appointment = val;
  }
  // 费用
  private getPriceList() {
    let parameters:any = {};
    parameters.user_id = UserModule.getUserId;
    parameters.company_id = this.serverCompanyId;
    getPriceList(parameters).then(res => {
      if (res.data) {
        this.costList = res.data.list;
      } else {
        this.costList = [];
      }
    }).catch(err => {
      let msg = err.msg;
    });
  }
  private priceChange(price:any) {
    this.$set(this.formInstall, 'costValue', price.price_num);
  }
  private priceNewChange(index:number, price:any) {
    this.$set(this.dynamicCost[index], 'value', price.price_num);
  }
  // 添加费用
  private addCostHandle() {
    this.dynamicCost.push({
      type: '',
      value: ''
    });
  }
  private removeCostHandle(v:any) {
    let index = this.dynamicCost.indexOf(v);
    if (index !== -1) {
      this.dynamicCost.splice(index, 1);
    }
  }
  // 选择品牌
  private brandVisible = false;
  private productBeanList:any = []
  private selectBrandHandle() {
    if (this.productBeanList && this.productBeanList.length >= 5) {
      this.showErrorMsg('最多只能添加5个品牌');
      return;
    }
    this.brandVisible = true;
  }

  private confirmBrandHandle(val:any) {
    this.productBeanList.push(val);
  }
  private cleanProduct(val:any, index:any) {
    this.productBeanList.splice(index, 1);
  }
  private closeBrandHandle(value: boolean) {
    this.brandVisible = value;
  }

  // 设备
  private deviceVisible = false
  private selectDevice:any = []
  private selectDeviceHandle() {
    if (this.selectDevice.length >= 5) {
      this.showErrorMsg('最多只能选择5个设备');
      return;
    }
    this.deviceVisible = true;
  }

  private confirmDeviceHandle(value: any) {
    if (this.selectDevice && this.selectDevice.length < 1) {
      this.selectDevice = value;
    } else {
      this.selectDevice = this.selectDevice.concat(value);
    }
  }
  private cleanDevice(val:any, index:any) {
    this.selectDevice.splice(index, 1);
  }
  private closeDeviceHandle(value: boolean) {
    this.deviceVisible = value;
  }

  // 备件
  private partsVisible = false;
  private companyId = '';
  private selectParts:any=[];
  private selectPartsHandle() {
    this.partsVisible = true;
    this.companyId = UserModule.getCompanyId;
  }
  private confirmPartsHandle(val:any) {
    this.selectParts.push(val);
  }
  private cleanPart(val:any, index:any) {
    this.selectParts.splice(index, 1);
  }
  private closeParts(val:boolean) {
    this.partsVisible = val;
  }
  // 立即添加
  private submit() {
    var parameters:any = {};
    // 1是自己报，2是替客户报
    parameters['order_create_type'] = '2';
    parameters['order_type'] = '3';

    parameters['user_id'] = UserModule.getUserId;
    parameters['user_name'] = UserModule.getUserName;

    parameters['company_id'] = UserModule.getCompanyId;
    parameters['servicer_company_id'] = UserModule.getCompanyId;
    parameters['servicer_company_name'] = UserModule.getCompanyName;
    if (!(this.formInstall.servicerDept && this.formInstall.servicerDept.dept_id) && this.isMustSerDept) {
      this.showErrorMsg('请选择服务部门');
      return;
    }
    if (this.formInstall.servicerDept) {
      if(this.isShowSerDept){
        parameters['servicer_dept_id'] = this.formInstall.servicerDept.dept_id;
        parameters['servicer_dept_name'] = this.formInstall.servicerDept.name;
      }
    }
    // 订单来源三选
    if (!(this.formInstall.source && this.formInstall.source.id) && this.isMustInstallSource) {
      this.showErrorMsg('请选择订单来源');
      return;
    }
    if (this.formInstall.source && this.formInstall.source.id) {
      parameters['install_source_id'] = this.formInstall.source.id;
      parameters['install_source_name'] = this.formInstall.source.name;
    }
    if (!this.formInstall.ordernumberOriginal && this.isMustInstallNum) {
      this.showErrorMsg('请输入订单原始单号');
      return;
    }
    if (this.formInstall.ordernumberOriginal) {
      parameters['order_original_num'] = this.formInstall.ordernumberOriginal;
    }
    if (!this.appointmentOriginalDayTimestamp && this.isMustInstallAppointment) {
      this.showErrorMsg('请选择原始预约时间');
      return;
    }
    if (this.appointmentOriginalDayTimestamp) {
      parameters['original_appointment_time'] = this.appointmentOriginalDayTimestamp;
    }
    if (!(this.selectTagArray && this.selectTagArray.length > 0) && this.isMustTag) {
      this.showErrorMsg('请添加订单标签');
      return;
    }
    if (this.selectTagArray && this.selectTagArray.length > 0) {
      var array:any = [];
      for (var i = 0; i < this.selectTagArray.length; i++) {
        var item = this.selectTagArray[i];
        var dic = {
          'tags_name': item.tags_name,
          'tags_id': item.tags_id
        };
        array.push(dic);
      }
      parameters['tags'] = JSON.stringify(array);
    }
    let troubleDes = '';
    let num = 0;
    if (this.formInstall.description) {
      num = num + 1;
      troubleDes = num + '、' + this.formInstall.description + ';';
    }
    this.dynamicDescription.forEach(des => {
      if (des.value) {
        num = num + 1;
        troubleDes = troubleDes + num + '、' + des.value + ';';
      }
    });

    if (!(troubleDes && troubleDes.length > 0) && this.isMustDescription) {
      this.showErrorMsg('请输入' + this.placeHolderDescription);
      return;
    }

    parameters['trouble_describle'] = troubleDes;
    // 客户
    if (this.isShowCustomer && (!this.formInstall.customer || !this.formInstall.customer.customer_type)) {
      this.showErrorMsg('请选择客户');
      return;
    }
    if (this.isShowCustomer) {
      switch (parseInt(this.formInstall.customer.customer_type)) {
        case 1:
          parameters['customer_company_id'] = this.formInstall.customer.customer_company_id;
          parameters['customer_company_name'] = this.formInstall.customer.name;
          break;
        case 2:
          parameters['customer_user_id'] = this.formInstall.customer.customer_user_id;
          parameters['customer_user_name'] = this.formInstall.customer.name;
          break;
      }
    } else {
      parameters['customer_company_id'] = UserModule.getCompanyId;
      parameters['customer_company_name'] = UserModule.getCompanyName;
    }
    if (!this.formInstall.area && this.isMustAddressPca) {
      this.showErrorMsg('请选择省市区');
      return;
    }
    if (!this.formInstall.area && this.isMustAddressSelf) {
      this.showErrorMsg('请选择所在地区');
      return;
    }
    if (!this.formInstall.address && this.isMustAddress) {
      this.showErrorMsg('请输入地址');
      return;
    }
    if (this.isShowAddressPca) {
      parameters['province_name'] = this.provinceName;
      parameters['city_name'] = this.cityName;
      parameters['district_name'] = this.districtName;
      parameters['province'] = this.province;
      parameters['city'] = this.city;
      parameters['district'] = this.district;
    }
    if (this.isShowAddressSelf) {
      parameters['address_type'] = 3;
      parameters['one_address_id'] = this.oneAddressId;
      parameters['one_address_name'] = this.oneAddress;
      parameters['two_address_id'] = this.twoAddressId;
      parameters['two_address_name'] = this.twoAddress;
      parameters['three_address_id'] = this.threeAddressId;
      parameters['three_address_name'] = this.threeAddress;
    }
    if (this.isShowAddress) {
      parameters['address'] = this.formInstall.address;
    }

    if (this.adcode) {
      parameters['adcode'] = this.adcode;
    }

    if (!this.formInstall.name && this.isMustContentUser) {
      this.showErrorMsg('请输入联系人姓名');
      return;
    }
    if (this.formInstall.name) {
      if (this.formInstall.name.length < 2 && this.formInstall.name.length > 10) {
        this.showErrorMsg('请输入2-10位联系人姓名');
        return;
      }
    }
    if (this.isShowContentUser) {
      parameters['name'] = this.formInstall.name;
    }

    if (!(this.formInstall.mobile && this.formInstall.mobile.length > 0) && this.isMustContentUserMobile) {
      this.showErrorMsg('请输入手机号码');
      return;
    }
    if (this.formInstall.mobile && this.formInstall.mobile.length > 0) {
      if (!(this.formInstall.mobile.charAt(0) === '1' && this.formInstall.mobile.length === 11)) {
        this.showErrorMsg('请输入正确的手机号码');
        return;
      }
      if (this.isShowContentUserMobile) {
        parameters['mobile'] = this.formInstall.mobile;
      }
    }
    if (!(this.formInstall.phone && this.formInstall.phone.length > 0) && this.isMustContentUserPhone) {
      this.showErrorMsg('请输入联系电话');
      return;
    }
    if (this.formInstall.phone && this.formInstall.phone.length > 0) {
      if (!(this.formInstall.phone.length >= 3 && this.formInstall.phone.length <= 18)) {
        this.showErrorMsg('请输入3-18位联系电话,支持输入"-"、" _"');
        return;
      }
      if (this.isShowContentUserPhone) {
        parameters['phone_num'] = this.formInstall.phone;
      }
    }
    if (!this.isMustContentUserPhone && !this.isMustContentUserMobile && this.isShowContentUserMobile && this.isShowContentUserPhone &&
    !(this.formInstall.mobile && this.formInstall.mobile.length > 0) && !(this.formInstall.phone && this.formInstall.phone.length > 0)) {
      this.showErrorMsg('请输入手机号码 或 3-18位联系电话,支持输入"-"、" _"');
      return;
    }

    if (!this.formInstall.appointment && this.isMustAppointment && !this.appointmentDayTimestamp) {
      this.showErrorMsg('请选择服务预约时间');
      return;
    }

    parameters['servicer_appointment_time'] = this.appointmentDayTimestamp;

    // 收费
    if (!this.formInstall.costRadio) {
      this.showErrorMsg('请选择是否收费');
      return;
    }
    parameters['is_charge'] = this.formInstall.costRadio;
    let costList:any = [];
    if (this.formInstall.costType && this.formInstall.costType.id) {
      let cost:any = {};
      cost.price_id = this.formInstall.costType.id;
      cost.price_name = this.formInstall.costType.price_name;
      cost.price_num = this.formInstall.costValue;
      costList.push(cost);
    }
    if (this.dynamicCost && this.dynamicCost.length > 0) {
      for (var cost of this.dynamicCost) {
        if (cost.type && cost.type.id) {
          let costs:any = {};
          costs.price_id = cost.type.id;
          costs.price_name = cost.type.price_name;
          costs.price_num = cost.value;
          costList.push(costs);
        }
      }
    }
    if (!(costList && costList.length > 0) && this.isMustPrice) {
      this.showErrorMsg('请添加费用');
      return;
    }
    if (costList && costList.length > 0) {
      var strCostList = JSON.stringify(costList);
      parameters['price'] = strCostList;
    }

    if ((!this.productBeanList || this.productBeanList.length < 1) && this.isMustProduct) {
      this.showErrorMsg('请添加品牌类型');
      return;
    }
    if (this.productBeanList && this.productBeanList.length > 0) {
      var str = JSON.stringify(this.productBeanList);
      parameters['product'] = str;
    }

    if (!(this.selectDevice && this.selectDevice.length > 0) && this.isMustDevice) {
      this.showErrorMsg('请添加设备');
      return;
    }
    if (this.selectDevice && this.selectDevice.length > 0) {
      var arrayDevice:any = [];
      this.selectDevice.forEach((device:any) => {
        var dic = {
          'device_id': device.id
        };
        arrayDevice.push(dic);
      });
      var strDevice = JSON.stringify(arrayDevice);
      parameters['device'] = strDevice;
    }

    if (!(this.selectParts && this.selectParts.length > 0) && this.isMustParts) {
      this.showErrorMsg('请添加备件');
      return;
    }
    if (this.selectParts && this.selectParts.length > 0) {
      var strParts = JSON.stringify(this.selectParts);
      parameters['parts'] = strParts;
    }

    if (!this.formInstall.remark && this.isMustRemark) {
      this.showErrorMsg('请添加备注');
      return;
    }
    if (this.formInstall.remark) {
      let remarkList:any = [];
      remarkList.push(this.formInstall.remark);
      var remark = JSON.stringify(remarkList);
      parameters['remark'] = remark;
    }

    if (this.formInstall.isSelf && (this.formInstall && this.formInstall.sendDept.length > 0) &&
    (!this.formInstall.sendDept || !this.formInstall.sendDept.dept_id)) {
      this.showErrorMsg('请选择自己的部门');
      return;
    }
    parameters['allot_dept_state'] = this.formInstall.isSelf ? 1 : 0;
    if (this.formInstall.sendDept) {
      parameters['allot_dept_id'] = this.formInstall.sendDept.dept_id;
      parameters['allot_dept_name'] = this.formInstall.sendDept.name;
    }

    createOrderService(parameters).then(res => {
      let _this = this;
      this.showSecussMsg((res as any).msg);
      let content = '是否立即处理订单';
      if (this.formInstall.isSelf) {
        content = '并成功给你分派任务，是否立即处理？';
      }
      this.$confirm(content, '添加成功', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          if (_this.formInstall.isSelf) {
            _this.$router.push({
              path: '/Task/todealing',
              query: { taskId: res.data.order_task_id, companyId: UserModule.getCompanyId, orderType: '2', enterType: '1' }
            });
          } else {
            _this.$router.push({
              path: '/OrderServicer/todealing',
              query: { order_service_id: res.data.order_service_id, company_id: UserModule.getCompanyId }
            });
          }
          _this.rest();
        })
        .catch(() => {
          _this.rest();
        });
    }).catch(err => {
      this.showErrorMsg(err.msg);
    });
  }
  private rest() {
    this.appointmentOriginalDayTimestamp = '';
    this.appointmentDayTimestamp = '';
    this.productBeanList = [];
    this.selectDevice = [];
    this.selectParts = [];
    this.dynamicDescription = [];
    this.adcode = '';
    this.provinceName = '';
    this.province = '';
    this.cityName = '';
    this.city = '';
    this.districtName = '';
    this.district = '';
    this.formInstall = {
      source: '',
      ordernumberOriginal: '',
      appointmentOriginal: '',
      servicerDept: {},
      description: '',
      customer: {},
      area: '',
      address: '',
      name: '',
      mobile: '',
      phone: '',
      appointment: '',
      costRadio: '',
      brand: '',
      device: '',
      parts: '',
      remark: '',
      isSelf: false,
      sendDept: (UserModule.getUserDeptList && UserModule.getUserDeptList.length === 1) ? UserModule.getUserDeptList[0] : ''
    };
  }
private pagination: any = {
  currentPage: 1,
  pageSize: 10,
  total: 0
}
private getInstallScourceList() {
  let paramters:any = {};
  paramters.user_id = UserModule.getUserId;
  paramters.company_id = UserModule.getCompanyId;
  paramters.page = this.pagination.currentPage;
  paramters.size = 9999;

  getInstallScourceList(paramters).then(res => {
    if (res.data) {
      this.sourceOptions = res.data.list;
      this.pagination.total = parseInt(res.data.count);
    } else {
      this.sourceOptions = [];
    }
  }).catch(err => {
    let msg = err.msg;
    this.sourceOptions = [];
    this.pagination.total = 0;
    this.pagination.currentPage = 1;
  });
}
private showErrorMsg(msg: string) {
  this.$notify({
    title: '提示',
    message: msg,
    offset: 100,
    type: 'error'
  });
}
private showSecussMsg(msg: string) {
  this.$notify({
    title: '提示',
    message: msg,
    offset: 100,
    type: 'success'
  });
}
}
